import { Set as ImmutableSet, fromJS } from 'immutable';
import { BOOLEAN, BUCKETS, ENUMERATION, STRING } from 'reporting-data/constants/property-types';
import { getDisplayParamsDataColumns, getReportConfig } from 'reporting-data/report/configReportGetters';
import { setDataColumns, setDimensions, setDisplayParamsStacking, setFrequency, setReportConfig } from 'reporting-data/report/configReportSetters';
const hasExternalOptionsObjectTypeProperty = property => {
  const hasExternalOptionsEnabled = !!property.get('externalOptions');
  const hasDeprecatedReferencedObjectType = property.get('referencedObjectType') !== null;
  const hasExternalOptionsReferenceType = property.get('externalOptionsReferenceType') !== null;
  const hasExternalOptionsEnabledWithReferenceType = hasExternalOptionsEnabled && (hasExternalOptionsReferenceType || hasDeprecatedReferencedObjectType);
  return hasExternalOptionsEnabledWithReferenceType;
};
const getIsIdProperty = property => {
  return property.get('type') === 'number' && hasExternalOptionsObjectTypeProperty(property);
};
const filterIsPropertyValidForDimension = property => {
  return !property.get('hidden') && ([STRING, ENUMERATION, BOOLEAN, BUCKETS].includes(property.get('type')) || getIsIdProperty(property));
};
export const parsePropertiesMapForPrompt = properties => {
  return properties.filter(filterIsPropertyValidForDimension).map(property => {
    return {
      name: property.get('name'),
      label: property.get('label'),
      type: property.get('type'),
      fieldType: property.get('fieldType'),
      description: property.get('description')
    };
  });
};
export const updateReportWithAIPromptReportResult = (report, promptResult) => {
  return report.withMutations(mutableReport => {
    const dataColumnsInOriginalReport = getDisplayParamsDataColumns(mutableReport) || fromJS([]);
    const dimensionsFromPrompt = [];

    // Model sets empty/null values as the string null
    if (promptResult.dimensionProperty && promptResult.dimensionProperty !== null) {
      dimensionsFromPrompt.push(promptResult.dimensionProperty);
    }
    if (promptResult.breakdownProperty && promptResult.breakdownProperty !== null && promptResult.dimensionProperty !== null) {
      dimensionsFromPrompt.push(promptResult.breakdownProperty);
    }
    const updatedDataColumns = ImmutableSet(dataColumnsInOriginalReport).union(ImmutableSet(dimensionsFromPrompt)).toList().toArray();
    const updatedDataColumnsInReport = setDataColumns(mutableReport, updatedDataColumns);
    const updatedDimensions = setReportConfig(updatedDataColumnsInReport, setDimensions(getReportConfig(mutableReport), fromJS(dimensionsFromPrompt)));
    const updatedStacking = setDisplayParamsStacking(updatedDimensions, promptResult.stacking);
    const updatedFreq = promptResult.frequency ? setReportConfig(updatedStacking, setFrequency(getReportConfig(updatedStacking), promptResult.frequency)) : updatedStacking;
    const updatedNameAndDescription = updatedFreq.set('name', promptResult.reportTitle).set('description', promptResult.reportDescription).set('chartType', promptResult.chartType);
    return updatedNameAndDescription;
  });
};